export const left_arrow = (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.333284C11.7806 0.332016 11.5632 0.374058 11.3601 0.456999C11.1571 0.53994 10.9724 0.662151 10.8167 0.81662L0.816655 10.8166C0.506237 11.1289 0.332001 11.5513 0.332001 11.9916C0.332001 12.4319 0.506237 12.8543 0.816655 13.1666L10.8167 23.1666C11.1355 23.4397 11.5456 23.5823 11.9651 23.5661C12.3845 23.5499 12.7824 23.3761 13.0793 23.0792C13.3761 22.7824 13.55 22.3845 13.5662 21.965C13.5824 21.5456 13.4397 21.1355 13.1667 20.8166L4.34999 12L13.1667 3.18328C13.4007 2.95116 13.5606 2.65486 13.6263 2.33184C13.6919 2.00882 13.6603 1.67358 13.5354 1.36853C13.4106 1.06348 13.198 0.802301 12.9247 0.618029C12.6514 0.433758 12.3296 0.334667 12 0.333284Z"
      fill="#23AA49"
    />
  </svg>
);